import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "templateWorkOrders",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage:
        "Loading template work orders...Dragging them in from the database...",
      sortBy: "name",
      fields: [
        { key: "template_name", label: "Name", sortable: true },
        {
          key: "template_description",
          label: "Template Description",
          sortable: true,
        },
        { key: "description", label: "Work Order Description", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    templateWorkOrders: function() {
      return this.$store.getters.templateWorkOrdersForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needTemplateWorkOrders", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
  methods: {},
};
